import type { JSONContent } from '@tiptap/core';
import { SuperLatexContent } from '@examdojo/super-latex';
import { v4 as uuid } from 'uuid';
import { ContentBlockType, SimpleSolverBlock, SolverStep } from '../../model';

export const convertSimpleSolverBlockToTiptap = (block: SimpleSolverBlock): JSONContent => {
  return {
    type: 'simpleSolver',
    attrs: {
      ...(block.name && { name: block.name }),
      initial_super_latex_content: block.initial_super_latex_content,
      ...(block.steps && { steps: block.steps }),
      ...(block.initial_description_content && { initial_description_content: block.initial_description_content }),
      ...(block.width && { width: block.width }),
      ...(block.latex_on_right !== undefined && { latex_on_right: block.latex_on_right }),
    },
  };
};

export function convertTiptapToSimpleSolverBlock(json: JSONContent): SimpleSolverBlock {
  const attrs = json.attrs ?? {};

  return {
    id: uuid(),
    type: ContentBlockType.SimpleSolver,
    initial_super_latex_content: attrs['initial_super_latex_content'] as SuperLatexContent,
    ...(attrs['name'] && { name: attrs['name'] as string }),
    ...(attrs['steps'] && { steps: attrs['steps'] as SolverStep[] }),
    ...(attrs['initial_description_content'] && { initial_description_content: attrs['initial_description_content'] }),
    ...(attrs['width'] && { width: attrs['width'] as number }),
    ...(attrs['latex_on_right'] !== undefined && { latex_on_right: attrs['latex_on_right'] as boolean }),
  };
}
